import { Instance } from '../lib/axiosInterceptor';

const USERS_API_BASE = '/api/v1/users';

export const tgLogsService = {
  getSummary: ({ timezone, from, to }) =>
    Instance.get(
      `${USERS_API_BASE}/billing/logs-summary?timezone=${encodeURIComponent(timezone || '')}&from=${from || ''}&to=${to || ''}`
    ),
  getLogs: ({ timezone, limit, lastDocId = '', logType = 'all', status = 'all', from, to }) =>
    Instance.get(
      `${USERS_API_BASE}/billing/logs?timezone=${timezone}&limit=${limit}&lastDocId=${lastDocId}&logType=${logType}&status=${status}&from=${from || ''}&to=${to || ''}`
    ),

  getStatusCounts: ({ from, to, timezone }) =>
    Instance.get(
      `${USERS_API_BASE}/billing/logs-status-counts?timezone=${encodeURIComponent(timezone || '')}&from=${from || ''}&to=${to || ''}`
    ),

  exportLogs: ({ from, to, timezone }) =>
    Instance.get(`${USERS_API_BASE}/billing/export-logs?from=${from}&to=${to}&timezone=${timezone}`),

  downloadLogs: ({ from, to, timezone }) =>
    Instance.get(
      `${USERS_API_BASE}/billing/export-logs/download?from=${from}&to=${to}&timezone=${encodeURIComponent(timezone || '')}`,
      { responseType: 'blob' }
    ),
};
